import React from 'react';
import {
  FaUsers,
  FaDollarSign,
  FaExclamationTriangle,
  FaMoneyBillWave,
  FaCheckCircle
} from 'react-icons/fa';

const formatMoney = (value) =>
  new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(value || 0);

const KpiCard = ({ icon: Icon, label, value, accent = 'text-e0e3-foreground', sub }) => (
  <div className="rounded-xl border border-e0e3-border/30 bg-e0e3-surface/30 px-4 py-3 min-w-0">
    <div className="flex items-center gap-2 text-e0e3-muted mb-1">
      <Icon size={14} className="shrink-0 text-e0e3-accent" />
      <p className="text-xs truncate">{label}</p>
    </div>
    <p className={`text-xl font-bold leading-tight truncate ${accent}`} title={String(value)}>
      {value}
    </p>
    {sub ? <p className="text-[11px] text-e0e3-muted mt-0.5">{sub}</p> : null}
  </div>
);

const CuentaCorrienteKpis = ({ kpis, diasCriterio }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
    <KpiCard icon={FaUsers} label="Clientes con deuda" value={kpis.clientesConDeuda} />
    <KpiCard icon={FaDollarSign} label="Total adeudado" value={formatMoney(kpis.totalAdeudado)} />
    <KpiCard
      icon={FaExclamationTriangle}
      label="Clientes vencidos"
      value={kpis.clientesVencidos}
      accent="text-red-200"
      sub={diasCriterio ? `>${diasCriterio} días` : null}
    />
    <KpiCard icon={FaMoneyBillWave} label="Cobros registrados hoy" value={kpis.cobrosRegistradosHoy} />
    <KpiCard icon={FaCheckCircle} label="Clientes al día" value={kpis.clientesAlDia} accent="text-emerald-200" />
  </div>
);

export default CuentaCorrienteKpis;
